<template>
	<div>
		<md-table>
			<md-table-row>
				<md-table-head>ល.រ.</md-table-head>
				<md-table-head>សមាជិក</md-table-head>
				<md-table-head>ភេទ</md-table-head>
				<md-table-head>ថ្ងៃខែឆ្នាំកំណើត</md-table-head>
				<md-table-head>អត្តសញ្ញាណប័ណ្ណ</md-table-head>
				<md-table-head>លេខទូរស័ព្ទ</md-table-head>
				<md-table-head>សាសនា</md-table-head>
				<md-table-head>កម្រិតវប្បធម៌</md-table-head>
				<md-table-head>តួនាទីរដ្ឋ/មុខរបរ</md-table-head>
				<md-table-head>សាខាគណបក្សសង្កាត់</md-table-head>
				<md-table-head>សាខាគណបក្សភូមិ</md-table-head>
				<md-table-head>ក្រុមបក្ស</md-table-head>
				<md-table-head>តួនាទីក្នុងបក្ស</md-table-head>
				<md-table-head>ថ្ងៃខែឆ្នាំចូលបក្ស</md-table-head>
				<md-table-head>លេខការិយាល័យបោះឆ្នោត</md-table-head>
				<md-table-head>សកម្មភាព</md-table-head>
			</md-table-row>
			<md-table-row v-for="(member, index) in memberList.slice(0,5)">
				<md-table-cell>{{index+1}}</md-table-cell>
				<md-table-cell>{{member.name}}</md-table-cell>
				<md-table-cell>{{getGender(member.gender)}}</md-table-cell>
				<md-table-cell>{{member.birth_date}}</md-table-cell>
				<md-table-cell>{{member.id_number}}</md-table-cell>
				<md-table-cell>{{member.phone}}</md-table-cell>
				<md-table-cell>{{member.religion_name}}</md-table-cell>
				<md-table-cell>{{member.education_name}}</md-table-cell>
				<md-table-cell>{{member.occupation}}</md-table-cell>
				<md-table-cell>{{member.commune_name}}</md-table-cell>
				<md-table-cell>{{member.village_name}}</md-table-cell>
				<md-table-cell>{{member.party_village_group}}</md-table-cell>
				<md-table-cell>{{member.party_position_name}}</md-table-cell>
				<md-table-cell>{{member.party_join_date}}</md-table-cell>
				<md-table-cell>{{member.election_office}}</md-table-cell>
				<md-table-cell>
					<a target="_blank" :href="`https://www.google.com/maps/search/?api=1&query=${member.lat},${member.lng}`">
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>place</md-icon>
							<md-tooltip md-direction="top">មើលទីតាំងសមាជិក</md-tooltip>
						</md-button>
					</a>
					<md-button class="md-just-icon md-simple md-primary">
						<md-icon>visibility</md-icon>
						<md-tooltip md-direction="top">មើលព័ត៌មានលម្អិតសមាជិក</md-tooltip>
					</md-button>
					<md-button class="md-just-icon md-simple md-info">
						<md-icon>edit</md-icon>
						<md-tooltip md-direction="top">កែប្រែព័ត៌មានសមាជិក</md-tooltip>
					</md-button>
					<md-button class="md-just-icon md-simple md-danger">
						<md-icon>close</md-icon>
						<md-tooltip md-direction="top">លុបសមាជិកចេញពីបញ្ជី</md-tooltip>
					</md-button>
				</md-table-cell>
			</md-table-row>
		</md-table>
	</div>
</template>

<script>
	export default {
		created() {
			this.searchHandler();
		},
		data() {
			return {
				memberList: [],
				search: {
					text: "",
					party_commune: "",
					party_village: "",
					party_village_group: "",
					party_position: "",
					education: "",
				},
			}
		},
		methods: {
			searchHandler() {
				this.$http.post(this.config.api + "/admin/member/search", {
					text: this.search.text,
					party_commune: this.search.party_commune,
					party_village: this.search.party_village,
					party_village_group: this.search.party_village_group,
					party_position: this.search.party_position,
					education: this.search.education,
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.memberList = data.body.data;
				})
			},
			getGender(type) {
				switch(type) {
					case 'm':
						return "ប្រុស"
					case 'f':
						return "ស្រី"
					default:
						return "ផ្សេងទៀត"
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/NewMemberTable.vue